import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import ChemComponent from '../ChemComponent';
import HashLink from '../HashLink';

class Home extends ChemComponent {	
	render() {
		return(
			<Container fluid>
			  <Row>
			    <Col md={12} lg={11} xl={10} style={{ paddingTop: '20px', paddingBottom: '20px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Helium/Liquid Air/Demurrage</span><br />
				  This is the home page for the Helium/Liquid Air/Demurrage application.<br />
				  <br />
				  <HashLink onClick={() => this.props.navigate('/HeLAD/Helium')}>Request Liquid Helium</HashLink>
				</Col>
			  </Row>
			</Container>
		);
	}
}

export default withRouter(Home);